var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('iframe',{ref:"mainFrame",attrs:{"src":_vm.createUrl(),"frameborder":"0"},on:{"~load":function($event){return _vm.load.apply(null, arguments)}}})}
var staticRenderFns = []

export { render, staticRenderFns }